class WhealthHomeCarousel extends HTMLElement {
  connectedCallback() {
    this.track=this.querySelector('.image-slides');
    if(!this.track || this.ready) return;
    this.ready=true;
    this.editor=this.dataset.editor==='true';
    this.originals=Array.from(this.track.children);
    this.logical=0;
    this.controller=new AbortController();
    const options={signal:this.controller.signal};
    this.querySelector('.image-next').addEventListener('click',()=>this.move(1),options);
    this.querySelector('.image-prev').addEventListener('click',()=>this.move(-1),options);
    this.track.addEventListener('transitionend',e=>{if(e.target===this.track)this.finish();},options);
    this.addEventListener('shopify:block:select',e=>{
      const card=e.target.closest('[data-block-id]');
      const index=this.originals.indexOf(card);
      if(index<0)return;
      this.logical=Math.min(index,Math.max(0,this.originals.length-this.visible));
      this.position=this.logical+this.cloneCount;
      this.render(false);
    },options);
    let start;
    this.track.addEventListener('touchstart',e=>{start=e.touches[0].clientX;}, {...options,passive:true});
    this.track.addEventListener('touchend',e=>{
      if(start===undefined)return;
      const delta=e.changedTouches[0].clientX-start;
      if(Math.abs(delta)>45)this.move(delta<0?1:-1);
      start=undefined;
    },options);
    this.resizeObserver=new ResizeObserver(()=>this.layout());
    this.resizeObserver.observe(this);
    this.layout();
    if(!this.editor && this.dataset.autoplay==='true') {
      this.timer=setInterval(()=>{if(!this.matches(':hover')&&!this.contains(document.activeElement))this.move(1);},Number(this.dataset.speed)||5000);
    }
  }
  layout() {
    const width=window.innerWidth;
    const visible=Math.min(this.originals.length,width<768?1:width<=990?Number(this.dataset.tablet):Number(this.dataset.desktop));
    if(visible===this.visible && this.width===this.clientWidth)return;
    this.visible=visible;this.width=this.clientWidth;
    this.style.setProperty('--carousel-columns',visible);
    this.track.querySelectorAll('.is-clone').forEach(e=>e.remove());
    this.cloneCount=this.editor?0:visible;
    const clone=el=>{
      const copy=el.cloneNode(true);copy.classList.add('is-clone');
      copy.removeAttribute('data-shopify-editor-block');copy.removeAttribute('data-block-id');
      copy.setAttribute('aria-hidden','true');copy.inert=true;
      return copy;
    };
    if(this.cloneCount){
      this.originals.slice(-visible).forEach(e=>this.track.insertBefore(clone(e),this.originals[0]));
      this.originals.slice(0,visible).forEach(e=>this.track.append(clone(e)));
    }
    this.logical=Math.min(this.logical,Math.max(0,this.originals.length-visible));
    this.position=this.logical+this.cloneCount;
    this.render(false);
  }
  render(animate) {
    clearTimeout(this.fallback);
    this.busy=animate;
    const step=this.originals[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(this.track).gap)||0);
    this.track.style.transition=animate?'transform 320ms ease':'none';
    this.track.style.transform='translateX(-'+this.position*step+'px)';
    const dots=this.querySelector('.image-dots');
    if(dots && !dots.children.length) this.originals.forEach((_,index)=>{
      const dot=document.createElement('button');dot.className='image-dot';
      dot.setAttribute('aria-label','Go to photo '+(index+1));
      dot.addEventListener('click',()=>{
        this.logical=Math.min(index,Math.max(0,this.originals.length-this.visible));
        this.position=this.logical+this.cloneCount;this.render(true);
      });dots.append(dot);
    });
    if(dots)Array.from(dots.children).forEach((dot,index)=>dot.classList.toggle('active',index===this.logical));
    if(animate)this.fallback=setTimeout(()=>this.finish(),400);
  }
  move(direction) {
    if(this.busy || this.originals.length<=this.visible)return;
    if(this.editor){
      const last=this.originals.length-this.visible;
      this.logical=this.logical+direction;
      if(this.logical>last)this.logical=0;
      if(this.logical<0)this.logical=last;
      this.position=this.logical;this.render(false);
    }else{
      this.logical=(this.logical+direction+this.originals.length)%this.originals.length;
      this.position+=direction;this.render(true);
    }
  }
  finish() {
    clearTimeout(this.fallback);this.busy=false;
    if(!this.editor){
      if(this.position>=this.originals.length+this.cloneCount)this.position-=this.originals.length;
      if(this.position<this.cloneCount)this.position+=this.originals.length;
      this.render(false);
    }
  }
  disconnectedCallback() {
    this.controller?.abort();this.resizeObserver?.disconnect();
    clearInterval(this.timer);clearTimeout(this.fallback);this.ready=false;
  }
}
if(!customElements.get('whealth-home-carousel'))customElements.define('whealth-home-carousel',WhealthHomeCarousel);
